import axios from "axios";
import * as types from "../mutation-types";
import "moment/dist/locale/de";
import moment from "moment/min/moment-with-locales";
import logger from "~/utilities/logger";

// state
export const state = {
  out_day_list: [],
  selected_out_day: null,
};

// getters
export const getters = {
  out_day_list: (state) => state.out_day_list,
  check_list: (state) => state.out_day_list !== null,
};

//utils
export const getOutDayById = (state, outId) =>
  state.out_day_list.findIndex((day) => day.out_id === outId);
export const getOutDayByDay = (state, day) =>
  state.out_day_list.findIndex(
    (d) => moment(d.out_day, "YYYY-MM-DD").day() === day
  );

// mutations
export const mutations = {
  [types.ADD_OUT_DAY](state, day)
  {
    return state.out_day_list.push(day);
  },
  [types.ADD_OUT_DAY_FAILURE](state, error) {},

  [types.FETCH_OUT_DAYS](state, { out_day_list })
  {
    return (state.out_day_list = out_day_list);
  },

  [types.FETCH_OUT_DAYS_FAILURE](state)
  {
    logger.error("FETCH_OUT_DAYS_FAILURE");
  },

  [types.FETCH_USER_OUT_DAYS](state, { out_day_list })
  {
    return (state.out_day_list = out_day_list);
  },

  [types.FETCH_USER_OUT_DAYS_FAILURE](state)
  {
    logger.error("FETCH_USER_OUT_DAYS_FAILURE");
  },

  [types.DELETE_OUT_DAY](state, { out_id })
  {
    logger.log("store.DELETE_OUT_DAY", state, out_id);
    const index = getOutDayById(state, out_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete outday (id ${out_id})`);
    }
    return state.out_day_list.splice(index, 1);
  },
};

// actions
export const actions = {
  async addOutDay({ commit }, outday)
  {
    try
    {
      logger.log("store.addOutDay", "/api/outdays", outday);

      const { data } = await axios.post("/api/outdays", outday);

      if (data?.status === "success")
      {
        logger.log("store.addOutday rsp", data);
        return commit(types.ADD_OUT_DAY, data.data);
      } else
      {
        return commit(types.ADD_OUT_DAY_FAILURE, data);
      }
    } catch (e)
    {
      logger.error("DELETE_OUT_DAY_FAILURE", e);
      return commit(types.ADD_OUT_DAY_FAILURE, e);
    }
  },

  async getOutDays({ commit }, options)
  {
    try
    {
      const paginate = options?.paginate || 10000;
      const extraOptions = options?.extra_options || "";
      const format = options?.format || "minimal";

      const url = `/api/outdays?status=active&paginate=${paginate}&format=${format}${extraOptions}`;

      const { data } = await axios.get(url);

      const out_day_list = data?.data?.data || data.data || [];

      logger.log("store.getOutDays", data);

      return commit(types.FETCH_OUT_DAYS, { out_day_list });
    } catch (e)
    {
      logger.error("store.getOutDays error", e);
      return commit(types.FETCH_OUT_DAYS_FAILURE);
    }
  },

  async getUserOutDays({ commit, dispatch }, payload)
  {
    const id = payload?.usr_id;
    if (!id) return;

    const paginate = payload?.paginate || 10000;
    const extraOptions = payload?.extra_options || "";

    const selected_date_min =
      payload?.selected_date_min || moment().format("DD.MM.yyyy");
    const theMonth = moment(selected_date_min, "DD.MM.yyyy").month() + 1; // jan=0, dec=11
    const theYear = moment(selected_date_min, "DD.MM.yyyy").year();

    const url = `/api/outdays/user/${id}/${theYear}/${theMonth}?paginate=${paginate}${extraOptions}`;
    logger.log("store.getUserOutDays", url);

    try
    {
      const { data } = await axios.get(url);

      if (data?.status !== "success") throw data;

      logger.log("store.getUserOutDays rsp", data);

      const out_day_list = data?.data || [];

      return commit(types.FETCH_USER_OUT_DAYS, { out_day_list });
    } catch (e)
    {
      logger.error("store.getUserOutDays error", e);
      return commit(types.FETCH_USER_OUT_DAYS_FAILURE, e);
    }
  },

  async deleteOutDay({ commit, dispatch }, payload)
  {
    const id = payload.out_id;
    if (!id) return;

    const extraOptions = payload?.extra_options || "";
    const url = `/api/outdays/${id}${extraOptions}`;

    try
    {
      const { data } = await axios.delete(url);

      logger.log("store.deleteOutDay rsp", data);

      return commit(types.DELETE_OUT_DAY, { out_id: id });
    } catch (e)
    {
      logger.error("DELETE_OUT_DAY_FAILURE", e);
      // return commit(types.DELETE_OUT_DAY_FAILURE, { error: e });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
